import React , { useState, useCallback } from 'react';
import _ from 'lodash';
import Carousel, { Modal, ModalGateway } from 'react-images';
import PagingSimple from './pagingSimple';

export default ({...props}) => {
		const data = {
			subtitle: 'Galeri',
			title: 'Galeri terkait JMTO',
			wording: 'Kumpulan Foto kegiatan terbaru dari JMTO',
			link: 'https://jmto.co.id',
			list: props.feed.data
		};

		const [ currentImage, setCurrentImage ] = useState(0);
		const [ viewerIsOpen, setViewerIsOpen ] = useState(false);

		const openLightbox = useCallback((event) => {			
			setCurrentImage(event.target.dataset["currimage"]);
			setViewerIsOpen(true);
		}, []);

		const closeLightbox = () => {
			setCurrentImage(0);
			setViewerIsOpen(false);
		};
		return (
			<div className="py-4_custom">
				<div className="container-fluid p-0">
					<div className="head text-center pb-4">
						<div>
							<h6 className="text-secondary text-uppercase">{data.subtitle}</h6>
						</div>
						<div className="my-3">
							<h2 className="text-primary text-uppercase font-weight-bold">{data.title}</h2>
						</div>
						<div>
							<h6 className="text-primary">{data.wording}</h6>
						</div>
					</div>
					<div className="main my-4 py-2">
						<div className="row no-gutters">
							{data.list.map((item, key) => (
								<div key={key} className="col-sm-6 col-md-6 col-lg-4">
									<div className="cell-grid h-100 position-relative">
										<div className="img-grid" style={{ backgroundImage: `url('${process.env.NEXT_PUBLIC_BASE_IMG+item.imgUrl}')` }} />
										<div className="position-absolute w-100 h-100 bg-primary_transparent p-4 collapse animated slideInUp">
											<div className="text-primary pt-4 mt-4 mb-4" dangerouslySetInnerHTML={{__html:
												_.truncate(item.body, { length: 250, separator: /,?\.* +/ })}}>
											</div>

											<button type="button"
												data-currimage={key}
												className="btn btn-sm btn-outline-primary"
												onClick={openLightbox}
											>
												Perbesar Gambar
											</button>
										</div>
									</div>
								</div>
							))}
						</div>
						<ModalGateway>
							{viewerIsOpen ? (
								<Modal onClose={closeLightbox}>
									<Carousel
										currentIndex={currentImage}
										views={data.list.map(x => ({
											src: process.env.NEXT_PUBLIC_BASE_IMG+x.imgUrl,
											caption: x.body
										}))}
									/>
								</Modal>
							) : null}
						</ModalGateway>
					</div>
					<div className="foot text-center">
						{props.usePage ? (
							<PagingSimple last_page={props.feed.meta.last_page} {...props} />
						) : (
							<a href={data.link} className="btn btn-outline-primary">
								Load More <i className="arrow right" />
							</a>
						)}
					</div>

				
				</div>
				<style jsx>
					{`
						@import './styles/jmto-custom';
						.text-secondary {
							letter-spacing: 2px;
						}
						.py-4_custom {
							padding-top: 6em;
							padding-bottom: 4em;
						}
						.img-grid {
							padding-bottom: 70%;
							background-position: center center;
							background-size: cover;
						}
						.icon-cover {
							margin-top: -42px;
						}
						.line-height_custom {
							line-height: 1.5em;
						}
						.bg-primary_transparent {
							background-color: rgba($white, 0.9);
							top: 0;
						}
						.cell-grid {
							overflow: hidden;
						}
						.cell-grid .bg-primary_transparent {
							animation-duration: .5s;
						}
						.cell-grid:hover {
							box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.16);
						}
						.cell-grid:hover .bg-primary_transparent {
							display: block;
						}
					`}
				</style>
			</div>
		);
	}
